import { render, staticRenderFns } from "./FoundUsers.vue?vue&type=template&id=21aef5f2&scoped=true"
import script from "./FoundUsers.vue?vue&type=script&lang=js"
export * from "./FoundUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21aef5f2",
  null
  
)

export default component.exports